import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import TransferList from './TransferList';

const ApexFundingAccountDeleteContent = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <PageContentContainer>
      <PageContentTop
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <ResourceSummaryCard resource={resource.attr('account').resources().head()} />
      <TransferList
        cancelableTransfers={resource.attr('cancellableAchTransfers')}
        nonCancelableTransfers={resource.attr('nonCancellableAchTransfers')}
      />
    </PageContentContainer>
  );
};

ApexFundingAccountDeleteContent.propTypes = {
};

export default ApexFundingAccountDeleteContent;
